module.exports = __webpack_public_path__ + "fb9056e331e6c82604b57f968569c857.MP3";